import { cm } from 'src/utils/classNames';
import { RadioGroupSize } from 'src/components/primitives/RadioGroup/types';
import { WithClassName } from 'src/utils/UtilityTypes';

interface GetRadioItemCardClassNameParams extends WithClassName {
	size: RadioGroupSize;
	disabled?: boolean;
}

export function getRadioItemCardClassName({
	size,
	disabled,
	className,
}: GetRadioItemCardClassNameParams) {
	const sizeClassName = {
		sm: 'h-2xl typo-label-xs',
		md: 'h-[34px] typo-label-sm',
		lg: 'h-[42px] typo-label-md',
	}[size];

	return cm(
		'flex items-center justify-center px-md',
		'rounded-sm border border-stroke-divider bg-button-disabled',
		disabled && 'cursor-not-allowed text-text-disabled',
		!disabled && [
			'text-text-secondary',
			'hover:bg-button-secondary-bg-hover hover:text-text-default',
			'data-[state=checked]:border-text-default data-[state=checked]:bg-button-selector data-[state=checked]:text-text-default',
		],
		sizeClassName,
		className
	);
}
